import React, { useEffect, useState } from 'react';
import './sustainability_report.css'
import {
  ParallaxProvider,
  ParallaxBanner,
  ParallaxBannerLayer,
} from "react-scroll-parallax";

// Images
import sustainability_report_img from '../../assets/sustainability_report_img.webp'


//Icons
import { MdArrowRightAlt } from "react-icons/md";

//AOS
import Aos from 'aos'
import 'aos/dist/aos.css'
import PopupMessage from './PopupMessage';

function SustainabilityReport() {

  const [popUpState, setPopUpState] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

  
  return (
    <ParallaxProvider>
      <div className="sus-rep-conatiner">
        <div className="sus-rep-main-contents">
          <div className="sus-rep-left-contents">
            <div className="sus-rep-back"></div>
            <div className="sus-rep-front-image">
              <ParallaxBanner
                style={{ aspectRatio: "1 / 0.8" }}
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <ParallaxBannerLayer
                  image={sustainability_report_img}
                  speed={6}
                />
              </ParallaxBanner>
            </div>
          </div>

          <div className="sus-rep-right-contents">
            <div className="sus-rep-right-content">
              <h1
                data-aos="fade-in"
                data-aos-duration="1000"
              >
                Future First <span className='title-second-color'>Strategy</span>
              </h1>
              <p
                data-aos="fade-in"
                data-aos-duration="1000"
                className='sus-rep-right-content-p'
              >
                <p>
                  Future First is our continued commitment to reducing environmental impact,
                  improving opportunities for people and communities and building trust across our business.
                </p>
                <p>
                  Put simply, it is our constant promise to do the right thing for a sustainable future.
                </p>
              </p>
            </div>

            <button className="learn-more-btn" onClick={() => setPopUpState(true)}>
              <span className="learn-more-text">Learn more</span>
              <span className="learn-more-icon">
                <MdArrowRightAlt size={20} color="#fff" />
              </span>
            </button>

            <PopupMessage setPopUpState={setPopUpState} popUpState={popUpState} />

          </div>
        </div>
      </div>
    </ParallaxProvider>
  );
}

export default SustainabilityReport